import { useState, useEffect } from "react";

const useFormHandler = (initialFormValues, callback, validate) => {
  const [inputs, setInputs] = useState(initialFormValues);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (Object.keys(errors).length === 0 && isSubmitting) {
      callback();
    }
  }, [errors]);

  const handleInputChange = (event) => {
    event.persist();
    setInputs((inputs) => ({ ...inputs, [event.target.name]: event.target.value }));
  };
  const insertLinkTag = () => {
    const selected = window.getSelection().toString();
    const link = `<a href="ADD_YOUR_URL_HERE" target="_blank">` + selected + `</a>`;
    if (inputs.otd_comment) inputs.otd_comment = inputs.otd_comment.replace(selected, link);
    setInputs((inputs) => ({ ...inputs }));
  };
  const insertImageTag = () => {
    inputs.otd_comment += ` <img src="ADD_YOUR_URL_HERE" class="img-responsive" border="0" />`;
    setInputs((inputs) => ({ ...inputs }));
  };
  const clearForm = () => {
    setInputs(initialFormValues);
  };

  const handleSubmit = (event) => {
    if (event) event.preventDefault();
    setErrors(validate(inputs));
    setIsSubmitting(true);
  };

  return {
    handleInputChange,
    handleSubmit,
    insertLinkTag,
    insertImageTag,
    inputs,
    clearForm,
    errors,
  };
};

export default useFormHandler;
